import type { StudentVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveStudentProfile = createApiThunk<StudentVM, void>(
  "students/retrieveStudentProfile",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.profile();
  },
);
